/* nt-chat.js — NatureTech theme-native support chat.
   SSE (Substrate -> Mastra ShopifyAgent) + rich widgets (product cards, chips,
   contact form), page-awareness, and a proactive nudge. All behavior is driven
   by data-* attributes set from the theme-editor settings on #nt-chat. */
(function () {
  var root = document.getElementById('nt-chat');
  if (!root) return;

  var attr = function (n, d) { var v = root.getAttribute(n); return v == null ? d : v; };
  var on = function (n) { return attr(n, 'true') !== 'false'; }; // default ON unless explicitly "false"
  var CFG = {
    endpoint: attr('data-endpoint', ''),
    shop: attr('data-shop', ''),
    cards: on('data-cards'),
    form: on('data-form'),
    chips: on('data-chips'),
    pageAware: on('data-page-aware'),
    persist: on('data-persist'),
    nudge: on('data-nudge'),
    nudgeDelay: Math.max(0, parseInt(attr('data-nudge-delay', '25'), 10) || 25),
    nudgeScroll: Math.max(0, parseInt(attr('data-nudge-scroll', '50'), 10) || 0),
    nudgeText: (attr('data-nudge-text', '') || '').trim(),
    pageType: attr('data-page-type', ''),
    pageTitle: attr('data-page-title', ''),
    product: (attr('data-product', '') || '').trim(),
    productHandle: (attr('data-product-handle', '') || '').trim(),
    url: attr('data-url', '')
  };
  var DEFAULT_WELCOME = "Hi, I'm your NatureTech grow buddy. Ask me about Homie, Wally or Tobato, your order, shipping, or what'll actually thrive on your balcony. I can find products and build your cart too.";

  var bubble = root.querySelector('.nt-chat__bubble');
  var panel = root.querySelector('.nt-chat__panel');
  var closeBtn = root.querySelector('.nt-chat__close');
  var log = root.querySelector('.nt-chat__log');
  var form = root.querySelector('.nt-chat__form');
  var input = root.querySelector('.nt-chat__input');
  var sendBtn = root.querySelector('.nt-chat__send');

  var streaming = false;
  var greeted = false;
  var convId = null;

  // engaged/nudged flags are intentionally per-tab-session (nudge once per visit).
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  // Conversation persistence. When CFG.persist is on we use localStorage (survives
  // browser restarts, ~7-day TTL); otherwise sessionStorage (current tab only).
  var STORE = CFG.persist ? window.localStorage : window.sessionStorage;
  var PERSIST_MS = 7 * 24 * 60 * 60 * 1000;
  var convo = { cid: null, ts: 0, msgs: [] };
  function loadConvo() {
    try {
      var d = JSON.parse(STORE.getItem('nt_chat_convo') || 'null');
      if (d && d.ts && (Date.now() - d.ts) < PERSIST_MS && Array.isArray(d.msgs)) { convId = d.cid || null; return { cid: d.cid || null, ts: d.ts, msgs: d.msgs }; }
    } catch (e) {}
    return { cid: null, ts: 0, msgs: [] };
  }
  function saveConvo() { convo.cid = convId; convo.ts = Date.now(); if (convo.msgs.length > 40) convo.msgs = convo.msgs.slice(-40); try { STORE.setItem('nt_chat_convo', JSON.stringify(convo)); } catch (e) {} }
  function pushConvo(r, t) { if (!t) return; convo.msgs.push({ r: r, t: t }); saveConvo(); }
  convo = loadConvo();
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(c) { try { return '$' + (Number(c) / 100).toFixed(2); } catch (e) { return ''; } }

  function md(text) {
    var s = esc(text.trim());
    s = s.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
    s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    var lines = s.split(/\n/), out = [], inList = false;
    for (var i = 0; i < lines.length; i++) {
      var ln = lines[i], h = ln.match(/^#{1,4}\s+(.*)$/), li = ln.match(/^\s*[-*]\s+(.*)$/);
      if (h) { if (inList) { out.push('</ul>'); inList = false; } out.push('<h3>' + h[1] + '</h3>'); }
      else if (li) { if (!inList) { out.push('<ul>'); inList = true; } out.push('<li>' + li[1] + '</li>'); }
      else { if (inList) { out.push('</ul>'); inList = false; } out.push(ln.trim() ? '<p>' + ln + '</p>' : ''); }
    }
    if (inList) out.push('</ul>');
    return out.join('');
  }

  function statusText(raw) { var m = raw.match(/\[\[STATUS\]\]([\s\S]*?)(?:\[\[\/STATUS\]\]|$)/); return m ? m[1].trim() : ''; }
  function stripWidgets(raw) {
    return raw
      .replace(/\[\[STATUS\]\][\s\S]*?\[\[\/STATUS\]\]/g, '').replace(/\[\[STATUS\]\][\s\S]*$/, '')
      .replace(/\[\[PRODUCT:[^\]]*\]\]/g, '').replace(/\[\[CHIPS:[^\]]*\]\]/g, '').replace(/\[\[CONTACT_FORM\]\]/g, '')
      .replace(/\[\[(?:PRODUCT|CHIPS|CONTACT_FORM|STATUS)[^\]]*$/, '').trim();
  }

  function addMsg(role, html) { var el = document.createElement('div'); el.className = 'nt-chat__msg nt-chat__msg--' + role; el.innerHTML = html; log.appendChild(el); scrollDown(); return el; }
  function addStatus() { var el = document.createElement('div'); el.className = 'nt-chat__status'; el.innerHTML = '<span class="nt-chat__dots"><i></i><i></i><i></i></span><span class="nt-chat__status-txt">Working…</span>'; log.appendChild(el); scrollDown(); return el; }
  function scrollDown() { log.scrollTop = log.scrollHeight; }

  async function renderProductCard(title) {
    if (!CFG.cards) return;
    var card = document.createElement('div');
    card.className = 'nt-chat__card nt-chat__card--loading';
    card.innerHTML = '<div class="nt-chat__card-skel"></div>';
    log.appendChild(card); scrollDown();
    try {
      var sres = await fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources%5Btype%5D=product&resources%5Blimit%5D=1', { headers: { 'Accept': 'application/json' } });
      var sjson = await sres.json();
      var prods = (((sjson.resources || {}).results || {}).products) || [];
      if (!prods.length) { card.remove(); return; }
      var handle = (prods[0].handle || (prods[0].url || '').split('/products/')[1] || '').split('?')[0];
      if (!handle) { card.remove(); return; }
      var p = await (await fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })).json();
      var variant = (p.variants || []).filter(function (v) { return v.available; })[0] || (p.variants || [])[0];
      var img = p.featured_image ? (p.featured_image.split('?')[0] + '?width=160') : '';
      card.classList.remove('nt-chat__card--loading');
      card.innerHTML =
        (img ? '<img class="nt-chat__card-img" src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '<div class="nt-chat__card-body">' +
          '<a class="nt-chat__card-title" href="/products/' + esc(handle) + '">' + esc(p.title) + '</a>' +
          '<div class="nt-chat__card-price">' + money(p.price) + (variant && !variant.available ? ' <span class="nt-chat__card-oos">Sold out</span>' : '') + '</div>' +
          '<div class="nt-chat__card-actions">' +
            '<a class="nt-chat__card-view" href="/products/' + esc(handle) + '">View</a>' +
            (variant && variant.available ? '<button type="button" class="nt-chat__card-add" data-vid="' + variant.id + '">Add to cart</button>' : '') +
          '</div></div>';
      var addBtn = card.querySelector('.nt-chat__card-add');
      if (addBtn) addBtn.addEventListener('click', function () { addToCart(addBtn); });
      scrollDown();
    } catch (e) { card.remove(); }
  }

  async function addToCart(btn) {
    if (btn.disabled) return;
    var vid = btn.getAttribute('data-vid');
    btn.disabled = true; btn.textContent = 'Adding…';
    try {
      var res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] }) });
      if (!res.ok) throw new Error('add failed');
      btn.textContent = 'Added ✓'; btn.classList.add('is-added');
      var actions = btn.parentNode;
      if (actions && !actions.querySelector('.nt-chat__card-cart')) { var a = document.createElement('a'); a.className = 'nt-chat__card-cart'; a.href = '/cart'; a.textContent = 'View cart'; actions.appendChild(a); }
      document.dispatchEvent(new CustomEvent('nt:cart:updated'));
    } catch (e) { btn.disabled = false; btn.textContent = 'Add to cart'; }
  }

  function renderChips(options) {
    if (!CFG.chips || !options.length) return;
    var wrap = document.createElement('div'); wrap.className = 'nt-chat__chips';
    options.forEach(function (opt) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'nt-chat__chip'; b.textContent = opt;
      b.addEventListener('click', function () { if (streaming) return; wrap.querySelectorAll('.nt-chat__chip').forEach(function (c) { c.disabled = true; }); submitMessage(opt); });
      wrap.appendChild(b);
    });
    log.appendChild(wrap); scrollDown();
  }

  function renderContactForm() {
    if (!CFG.form || log.querySelector('.nt-chat__cform')) return;
    var f = document.createElement('form'); f.className = 'nt-chat__cform';
    f.innerHTML =
      '<div class="nt-chat__cform-title">Send us a message</div>' +
      '<input name="contact[name]" type="text" placeholder="Your name" required>' +
      '<input name="contact[email]" type="email" placeholder="Email" required>' +
      '<textarea name="contact[body]" rows="3" placeholder="How can we help?" required></textarea>' +
      '<button type="submit">Send</button>';
    f.addEventListener('submit', async function (e) {
      e.preventDefault();
      var btn = f.querySelector('button'); btn.disabled = true; btn.textContent = 'Sending…';
      try { var fd = new FormData(f); fd.append('form_type', 'contact'); fd.append('utf8', '✓'); await fetch('/contact', { method: 'POST', body: fd }); f.innerHTML = '<div class="nt-chat__cform-done">Thanks, we got it. Our team will reach out by email soon.</div>'; }
      catch (err) { btn.disabled = false; btn.textContent = 'Send'; }
    });
    log.appendChild(f); scrollDown();
  }

  function renderWidgets(raw) {
    var re = /\[\[PRODUCT:([^\]]+)\]\]/g, m, titles = [];
    while ((m = re.exec(raw))) { var t = m[1].trim(); if (t && titles.indexOf(t) < 0) titles.push(t); }
    titles.slice(0, 4).forEach(renderProductCard);
    var cm = raw.match(/\[\[CHIPS:([^\]]+)\]\]/);
    if (cm) renderChips(cm[1].split('|').map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 5));
    if (/\[\[CONTACT_FORM\]\]/.test(raw)) renderContactForm();
  }

  // ---- nudge -----------------------------------------------------------------
  function nudgeMessage() {
    if (CFG.nudgeText) return CFG.nudgeText.replace(/\{product\}/g, CFG.product || 'our systems');
    if (CFG.product) return "I noticed you're checking out the " + CFG.product + ". Happy to answer any questions, or help you compare it with our other systems. What can I help with?";
    if (CFG.pageType === 'product') return "Looking at one of our systems? I can answer questions or help you pick the right one. What are you growing?";
    return "Hey, I'm right here if you need a hand finding the right setup, or have a question about shipping or an order.";
  }
  function nudgeChips() {
    if (!CFG.chips) return [];
    if (CFG.product) return ['Tell me more about ' + CFG.product, 'Compare your systems', 'Shipping & delivery'];
    return ['Help me choose a system', 'Shipping & delivery', 'Talk to a human'];
  }

  function openPanel(opts) {
    opts = opts || {};
    ss('nt_chat_engaged', '1');
    root.classList.add('is-open'); panel.hidden = false; bubble.setAttribute('aria-expanded', 'true');
    if (!greeted) {
      greeted = true;
      addMsg('bot', md(opts.nudge ? nudgeMessage() : DEFAULT_WELCOME));
      if (opts.nudge) renderChips(nudgeChips());
    }
    setTimeout(function () { input.focus(); }, 100);
  }
  function closePanel() { root.classList.remove('is-open'); panel.hidden = true; bubble.setAttribute('aria-expanded', 'false'); }

  function scheduleNudge() {
    if (!CFG.nudge) return;
    if (convo.msgs.length) return; // returning chatter already has a conversation
    if (ss('nt_chat_engaged') === '1' || ss('nt_chat_nudged') === '1') return;
    var fired = false;
    var fire = function () {
      if (fired) return; fired = true;
      if (ss('nt_chat_engaged') === '1' || ss('nt_chat_nudged') === '1' || root.classList.contains('is-open')) return;
      ss('nt_chat_nudged', '1');
      openPanel({ nudge: true });
    };
    var t = CFG.nudgeDelay > 0 ? setTimeout(fire, CFG.nudgeDelay * 1000) : null;
    if (CFG.nudgeScroll > 0) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
        if (pct >= CFG.nudgeScroll) { window.removeEventListener('scroll', onScroll); if (t) clearTimeout(t); fire(); }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  bubble.addEventListener('click', function () { root.classList.contains('is-open') ? closePanel() : openPanel(); });
  closeBtn.addEventListener('click', closePanel);

  // Start a fresh thread: clear the log + stored history and null the conversation
  // id so the agent opens a brand-new Substrate conversation on the next message.
  var newBtn = root.querySelector('.nt-chat__newchat');
  function newThread() {
    if (streaming) return;
    convId = null;
    convo = { cid: null, ts: 0, msgs: [] };
    try { STORE.removeItem('nt_chat_convo'); } catch (e) {}
    log.innerHTML = '';
    greeted = true;
    addMsg('bot', md(DEFAULT_WELCOME));
    input.focus();
  }
  if (newBtn) newBtn.addEventListener('click', newThread);

  function submitMessage(text) { if (!text || streaming) return; addMsg('user', esc(text)); pushConvo('user', text); send(text); }
  form.addEventListener('submit', function (e) { e.preventDefault(); var text = input.value.trim(); if (!text || streaming) return; input.value = ''; submitMessage(text); });

  async function send(message) {
    streaming = true; sendBtn.disabled = true;
    var statusEl = addStatus(), botEl = null, raw = '';
    function render() {
      var clean = stripWidgets(raw), st = statusText(raw);
      if (st && statusEl) statusEl.querySelector('.nt-chat__status-txt').textContent = st;
      if (clean) { if (!botEl) { if (statusEl) { statusEl.remove(); statusEl = null; } botEl = addMsg('bot', ''); } botEl.innerHTML = md(clean); scrollDown(); }
    }
    try {
      var headers = { 'Content-Type': 'application/json', 'x-shopify-shop-url': CFG.shop };
      if (convId) headers['x-shopify-conversation-id'] = convId;
      var body = { message: message, conversation_id: convId };
      if (CFG.pageAware && (CFG.product || CFG.pageType)) {
        body.page_context = { type: CFG.pageType, title: CFG.pageTitle, product: CFG.product, handle: CFG.productHandle, url: CFG.url };
      }
      // Send recent turns (last 8, excluding the just-added current message) so the
      // agent remembers the conversation across pages/sessions. Token-bounded.
      var prior = convo.msgs.slice(0, -1).slice(-8);
      if (prior.length) body.history = prior.map(function (m) { return { role: m.r === 'bot' ? 'assistant' : 'user', content: m.t }; });
      var res = await fetch(CFG.endpoint, { method: 'POST', headers: headers, body: JSON.stringify(body) });
      if (!res.ok || !res.body) throw new Error('http ' + res.status);
      var reader = res.body.getReader(), dec = new TextDecoder(), buf = '';
      while (true) {
        var r = await reader.read(); if (r.done) break;
        buf += dec.decode(r.value, { stream: true });
        var idx;
        while ((idx = buf.indexOf('\n\n')) >= 0) {
          var evt = buf.slice(0, idx); buf = buf.slice(idx + 2);
          evt.split('\n').forEach(function (line) {
            line = line.trim(); if (line.indexOf('data:') !== 0) return;
            var payload = line.slice(5).trim(); if (!payload) return;
            var o; try { o = JSON.parse(payload); } catch (e) { return; }
            if (o.type === 'id' && o.conversation_id) { convId = o.conversation_id; saveConvo(); }
            else if (o.type === 'chunk' && typeof o.chunk === 'string') { raw += o.chunk; render(); }
            else if (o.type === 'error') { raw += '\n\nSorry, something went wrong. Please try again or contact support.'; render(); }
          });
        }
      }
      render();
      var botText = stripWidgets(raw);
      if (!botText && !botEl) { if (statusEl) statusEl.remove(); botText = 'Sorry, I did not catch that. Could you rephrase?'; addMsg('bot', md(botText)); }
      if (botText) pushConvo('bot', botText);
      renderWidgets(raw);
    } catch (err) {
      if (statusEl) statusEl.remove();
      addMsg('bot', md('I am having trouble connecting right now. Please try again in a moment, or email info@nthydroponics.com.'));
    } finally {
      if (statusEl && !botEl) statusEl.remove();
      streaming = false; sendBtn.disabled = false; input.focus();
    }
  }

  // Rehydrate a saved conversation. Panel stays closed (bubble); opening shows history.
  function addBubble(r, t) { var el = document.createElement('div'); el.className = 'nt-chat__msg nt-chat__msg--' + (r === 'bot' ? 'bot' : 'user'); el.innerHTML = (r === 'bot') ? md(t) : esc(t); log.appendChild(el); }
  if (convo.msgs.length) { convo.msgs.forEach(function (m) { addBubble(m.r, m.t); }); greeted = true; scrollDown(); }

  scheduleNudge();
})();
